__turbopack_context__.v({
  "alert": "PI6GIG_alert",
  "alertActions": "PI6GIG_alertActions",
  "alertBody": "PI6GIG_alertBody",
  "alertTitle": "PI6GIG_alertTitle",
  "avatar": "PI6GIG_avatar",
  "blink": "PI6GIG_blink",
  "bones": "PI6GIG_bones",
  "bottom": "PI6GIG_bottom",
  "box": "PI6GIG_box",
  "brand": "PI6GIG_brand",
  "chip": "PI6GIG_chip",
  "clock": "PI6GIG_clock",
  "compose": "PI6GIG_compose",
  "contact": "PI6GIG_contact",
  "cover": "PI6GIG_cover",
  "feed": "PI6GIG_feed",
  "frame": "PI6GIG_frame",
  "gap": "PI6GIG_gap",
  "handoff": "PI6GIG_handoff",
  "hud": "PI6GIG_hud",
  "label": "PI6GIG_label",
  "marks": "PI6GIG_marks",
  "msg": "PI6GIG_msg",
  "notice": "PI6GIG_notice",
  "noticeBody": "PI6GIG_noticeBody",
  "noticeDot": "PI6GIG_noticeDot",
  "noticeTitle": "PI6GIG_noticeTitle",
  "overlay": "PI6GIG_overlay",
  "person": "PI6GIG_person",
  "phone": "PI6GIG_phone",
  "phoneHead": "PI6GIG_phoneHead",
  "phoneUi": "PI6GIG_phoneUi",
  "rec": "PI6GIG_rec",
  "recDot": "PI6GIG_recDot",
  "state": "PI6GIG_state",
  "sub": "PI6GIG_sub",
  "tag": "PI6GIG_tag",
  "tagCard": "PI6GIG_tagCard",
  "tagDot": "PI6GIG_tagDot",
  "tagLine": "PI6GIG_tagLine",
  "tagName": "PI6GIG_tagName",
  "thread": "PI6GIG_thread",
  "time": "PI6GIG_time",
  "top": "PI6GIG_top",
  "who": "PI6GIG_who",
});
